<template>
    <div>
    <div id="footer" class="footer fixed-bottom icoWorkSpace w-100 ml-0 mr-0 d-flex justify-content-center">

           
            <!--Prepnúť jazykovú verziu obsahu - anglicky jazyk-->        
            <div class="flagExtern setLang mt-1 mb-1 " :data-title="$t('footer.1')">
                <img v-if="$i18n.locale=='en'" @click="changeLanguage" src="img/sk.jpg" alt="" class="flag" />
                <img v-if="$i18n.locale=='sk'" @click="changeLanguage" src="img/en.jpg" alt="" class="flag" />
                <!--<img class="flag" src="/img/EN.jpg" />--->    
            </div>        
            
            <!--Stiahnuť tento životopis vo formáte PDF-->
            <div style="" class="adobeAcro icoExtern mt-1 mb-1 " :data-title="$t('footer.2')">

                <a  target="parent" class="adobeAcrobatHref" :href="$i18n.locale + '.pdf'">
                    <i class="fas fa-file-pdf"></i>
                </a>
            </div>        
            
            <!--
            < !--Zdrojový kód tohto životopisu (VUE JS 3)-- >
            <div style="" class="openGithub icoExtern mt-1 mb-1 " :data-title="$t('footer.3')">
                <a  target="parent" href="https://github.com/russell1969Din/_________A_ABNet.sk-new">
                    <i class="fab fa-github-square"></i>
                </a>
            </div>        

            < !--Profil osoby z tohto životopisu v rámci sociálnej siete Facebook-- >
            <div style="" class="icoExtern facebook mt-1 mb-1 " :data-title="$t('footer.4')">
                <a  target="parent" href="https://www.facebook.com/rastislav.rehak1/">
                    <i class="fab fa-facebook-square"></i>
                </a>
            </div>
            
            < !--Profil osoby z tohto životopisu v rámci sociálnej siete LinkedIn-- >
            <div style="" class="icoExtern linkedIn mt-1 mb-1 " :data-title="$t('footer.5')">
                <a  target="parent" href="https://www.linkedin.com/in/rastislav-rehák-a14b191b6/">
                    <i class="fab fa-linkedin"></i>
                </a>
            </div>        
            -->

            <!---
            <div style="" class="icoExtern downloadZIP download mt-1 mb-1 " data-title="">
                <a  target="parent" href="/download/demo.zip" >
                    <i class="fas fa-download"></i>
                </a>
            </div>        
            -->
     </div>
    </div>
</template>

<script>
    export default {
        methods: {
            changeLanguage() {
                let solved = false
                if(this.$i18n.locale == 'sk' && !solved )   {
                    solved = true
                    this.$i18n.locale = 'en'
                }
                if(this.$i18n.locale == 'en' && !solved)   {
                    solved = true
                    this.$i18n.locale = 'sk'
                }
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>